import { queryClient } from '@contexts/queryClient';

import { SplashNotification } from '@queries/UserQueries';

export const openSplashNotification = (splashNotification: SplashNotification) => {
  const currentUser = queryClient.getQueryData<{
    splashNotifications: SplashNotification[];
  }>(['user']);

  const updatedCurrentUser = {
    ...currentUser,
    splashNotifications: [splashNotification, ...(currentUser?.splashNotifications ?? [])],
  };

  queryClient.setQueryData(['user'], updatedCurrentUser);
};
